module.exports = __webpack_public_path__ + "static/2-871cd8681af36b96871ea82008d65bba.jpg";